const smoker = [

    {label:"Years as smoker:",
    controlType:"number",
    options:[]
    },

    {label:"Cigarettes / day",
    controlType:"number",
    options:[]
    },


    {label:"Stopped smoking:",
    controlType:"radio button",
    options:["Yes", "No"]
    },

    {label:"Stopped for:",
    controlType:"radio button",
    options:["<1 year", "1-5 years", "5-10 years", ">10 years"]
    },
]

    export default smoker



